import { render, staticRenderFns } from "./GenerarExcelAsientos.vue?vue&type=template&id=2407fc4c"
import script from "./GenerarExcelAsientos.vue?vue&type=script&setup=true&lang=js"
export * from "./GenerarExcelAsientos.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports